import QuantityProduct from './QuantityProduct'

class DigitalRetouchedRenovationPhotoProduct extends QuantityProduct {}

export default DigitalRetouchedRenovationPhotoProduct
